import { Colonne } from "../../class/userinterface";
import { AnaColumn } from "../forms-template.service";

export const utentiDiOwner: AnaColumn[] = [
  {

    itemType: "group", colCount: "2", colSpan: "2", data: [

      { type: 'button', horizontalAlignment: 'center', hideOnEdit: true, disableOnUpdate: true, button: { event: "OptionalIconButtonClick", name: "resetPwd", hint: "Reinvia", icon: "revert" } },
      {
        type: 'campo', disableOnUpdate: true, dataField: "userName", dataType: "", caption: "User",
        iconButton: true,
        placeHolder: 'examples@example.it',
        allowFiltering: false,
        horizontalAlignment: 'center',
        button: { name: "cercauser", location: "after", icon: "revert" },
        validation: [{ type: "required", message: "Indicare email come userame" }]
      },
      {
        type: 'campo', disableOnUpdate: true, width: "210px", dataField: "tipoUtente", dataType: "number", editorType: "dxSelectBox",

        validation: [{ type: "required", message: "Campo Obbligatorio" }],
        caption: "Tipo Utente",
        lista: {
          dataSource: 'tipoutente',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: true
        }
      },
      {
        type: 'campo', hideOnEdit: true, disableOnUpdate: true, dataField: "guidAccettazione", dataType: "",
        caption: "Invito", allowFiltering: false, labelAlignment: 'center', colWidth: 'auto', horizontalAlignment: 'center'
      },
    ]
  },
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      {
        disableOnUpdate: false, type: 'campo', dataField: "nomeCompleto", dataType: "", caption: "Nome Completo",
        validation: [{ type: "required", message: "Campo Obbligatorio" }]
      },
      {
        disableOnUpdate: false, minLength: '11', maxLength: '16', type: 'campo', dataField: "codiceFiscale", dataType: "", caption: "Codice Fiscale",

      },
    ]
  },
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      { disableOnUpdate: false, type: 'campo', dataField: "emailRecupero", dataType: "", caption: "Email Recupero" },
      { disableOnUpdate: false, type: 'campo', dataField: "emailComunicazioni", dataType: "", caption: "Email Comunicazioni" },
    ]
  },
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      {
        disableOnUpdate: false, type: 'campo', dataField: "telefono", dataType: "", caption: "Telefono",//editorType:'dxNumberBox',
        format: '#0#', patterns: '0123456789',
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },
      { type: 'campo', dataField: "sospeso", dataType: "boolean", caption: "Sospeso" },
    ]
  },
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      {
        disableOnUpdate: false, type: 'campo', dataField: "scadenzaAccount", dataType: "date", caption: "Scadenza Account",
      },

      /*{
        disableOnUpdate: false, visible:false, readonly:true,  type: 'campo', dataField: "scadenzaPassword",  dataType: "date", caption: "Scadenza Password",
      },*/
    ]
  },

]




export const utenti: AnaColumn[] = [
  {


    itemType: "group", colCount: "2", colSpan: "2", data: [

      { type: 'button', hideOnEdit: true, disableOnUpdate: true, horizontalAlignment: 'center', button: { event: "OptionalIconButtonClick", name: "resetPwd", hint: "Reinvia", icon: "revert" } },
      /*{ type: 'button', hideOnEdit: true, disableOnUpdate: true,horizontalAlignment:'center',  button: { event: "OptionalIconButtonClick", name: "PermessiutentiComponent", hint: "Gestisci Permessi", icon: "user" } },*/
      { type: 'button', hideOnEdit: true, disableOnUpdate: true, horizontalAlignment: 'center', button: { event: "OptionalIconButtonClick", name: "InfousergruppiComponent", hint: "Appartenenza Gruppi", icon: "group" } },
      {
        type: 'campo', disableOnUpdate: true, dataField: "userName", dataType: "", caption: "User",
        iconButton: true,
        placeHolder: 'examples@example.it',
        allowFiltering: false,
        button: { name: "cercauser", location: "after", icon: "revert" },
        validation: [{ type: "required", message: "Indicare email come userame" }]
      },
      {
        type: 'campo', disableOnUpdate: true, width: "210px", dataField: "tipoUtente", dataType: "number", editorType: "dxSelectBox",

        validation: [{ type: "required", message: "Campo Obbligatorio" }],
        caption: "Tipo Utente",
        lista: {
          dataSource: 'tipoutente',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: true
        }
      },
      {
        type: 'campo', hideOnEdit: true, disableOnUpdate: true, dataField: "guidAccettazione", dataType: "",
        caption: "Invito", allowFiltering: false, labelAlignment: 'center', colWidth: 'auto', horizontalAlignment: 'center'
      },
    ]
  },
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      {
        disableOnUpdate: false, type: 'campo', dataField: "nomeCompleto", dataType: "", caption: "Nome Completo", visible: false,

      },
      {
        disableOnUpdate: false, type: 'campo', dataField: "nome", dataType: "", caption: "Nome", colVisible: false, validation: [{ type: "required", message: "Campo Obbligatorio" }]
      },
      {
        disableOnUpdate: false, type: 'campo', dataField: "cognome", dataType: "", caption: "Cognome", colVisible: false, validation: [{ type: "required", message: "Campo Obbligatorio" }]
      },
      {
        disableOnUpdate: false, minLength: '11', maxLength: '16', type: 'campo', dataField: "codiceFiscale", dataType: "", caption: "Codice Fiscale",


      },
    ]
  },
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      { disableOnUpdate: false, type: 'campo', dataField: "emailRecupero", dataType: "", caption: "Email Recupero" },
      { disableOnUpdate: false, type: 'campo', dataField: "emailComunicazioni", dataType: "", caption: "Email Comunicazioni" },
    ]
  },
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      {
        disableOnUpdate: false, type: 'campo', dataField: "telefono", dataType: "", caption: "Telefono",//editorType:'dxNumberBox',
        format: '#0#', patterns: '0123456789',
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },
      { type: 'campo', colAlignment: 'center', dataField: "sospeso", dataType: "boolean", caption: "Sospeso" },
    ]
  },
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      {
        disableOnUpdate: false, type: 'campo', dataField: "scadenzaAccount", dataType: "date", caption: "Scadenza Account",
      },
      /*{
        disableOnUpdate: false, visible:false, readonly:true,  type: 'campo', dataField: "scadenzaPassword",  dataType: "date", caption: "Scadenza Password",
      },*/
    ]
  },



  {
    itemType: "group", colCount: '10', class: "UtenteApp", data: [
      { type: 'campo', visible: true, colAlignment: 'center', colVisible: true, colSpan: '4', dataField: "firmaRentriAutista", dataType: "boolean", caption: "Trasportatore" },
      { type: 'campo', visible: true, colAlignment: 'center', colVisible: true, colSpan: '3', dataField: "firmaRentriProduttore", dataType: "boolean", caption: "Produttore" },
      { type: 'campo', visible: true, colAlignment: 'center', colVisible: true, colSpan: '2', dataField: "firmaRentriSmaltitore", dataType: "boolean", caption: "Smaltitore" },

      /*{ type: 'campo', colSpan:'4',dataField: "consulente", dataType: "boolean", caption: "Consulente" },
    { type: 'campo', colSpan:'2',dataField: "associazione", dataType: "boolean", caption: "Associazione" },
     */

    ]
  },
  {
    itemType: "group", class: "UtenteApp", colCount: '10', data: [
      { type: 'campo', colAlignment: 'center', visible: true, colVisible: true, colSpan: '3', dataField: "firmaRentriConsulente", dataType: "boolean", caption: "Consulente" },
      { type: 'campo', colAlignment: 'center', visible: true, colVisible: true, colSpan: '3', dataField: "firmaRentriIntermediario", dataType: "boolean", caption: "Interm." },
      { type: 'campo', colAlignment: 'center', visible: true, colVisible: true, colSpan: '3', dataField: "firmaRentriAssociazione", dataType: "boolean", caption: "Associazione" },
    ]
  },

]  